<template>
  <div id="app">
    <TopNav v-if="display" />
    <LeftNav v-if="display" />
   <router-view :class="{'mleft130':!leftCollapse}"></router-view> 
  </div>
</template>

<style>
  @import url('./assets/css/common.css');
  @import url('./assets/css/responsive.css');
</style>
<script>
  import LeftNav from "./components/nav/LeftNav.vue";
  import TopNav from "./components/nav/TopNav.vue";
  import {
    mapGetters
  } from 'vuex';
  export default {
    name: 'app',
    computed: {
      ...mapGetters([
        'isLoggedIn','leftCollapse'
      ]),
      display(){
       //return true;
        //  return this.isLoggedIn;
        if(this.$route.name=='login')
         return false;
        return   this.isLoggedIn || localStorage.getItem('ss') ;
      }
    },
    components: {
      LeftNav,
      TopNav,
    },
    
    created(){
     
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #f3f6fb;
  }
  .mleft130{
    margin-left:195px;
  }
  .clearfix:before .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
  .break-word {
    word-wrap: break-word;
  }
  /*解决弹窗晃动*/
  /* html{overflow-y: scroll;}
  :root{ overflow-y: auto; overflow-x: hidden;}
  :root body{ position: absolute;}
  body {
    width: 100vw;
    overflow: hidden;
    margin: 0;
    padding: 0;
  } */
</style>
